import { createReducer, createSetter } from "@/redux/helpers/reducer";

import { DISPLAY_MODE_FULL_BREAKDOWN } from "../CreateDocumentModal/constants";

import * as actions from "./create-partial-invoice.actions";

const initialState = {
  isOpen: false,
  invoiceDate: null,
  activeTab: "actual",
  displayMode: DISPLAY_MODE_FULL_BREAKDOWN,
  lastGeneratedDisplayMode: null,
  oneLinerDescription: "",
  groupedLabourLabel: "",
  groupedMaterialsLabel: "",
  invoiceDisplayModeStatus: null,
  amountMode: null,
  selectedItemUids: [],
  itemAmounts: {},
  deliveryFee: "",
  specificAmount: "",
  percentage: "",
  partialSummary: null,
  partialSummaryStatus: null,
  additionalProducts: [],
  additionalProductsStatus: null,
  lastSubmittedId: null,
  lastSubmittedPayload: null,
};

export default createReducer(initialState, {
  [actions.setIsOpen]: createSetter("isOpen"),
  [actions.setInvoiceDate]: createSetter("invoiceDate"),
  [actions.setActiveTab]: createSetter("activeTab"),
  [actions.setDisplayMode]: createSetter("displayMode"),
  [actions.setLastGeneratedDisplayMode]: createSetter("lastGeneratedDisplayMode"),
  [actions.setOneLinerDescription]: createSetter("oneLinerDescription"),
  [actions.setGroupedLabourLabel]: createSetter("groupedLabourLabel"),
  [actions.setGroupedMaterialsLabel]: createSetter("groupedMaterialsLabel"),
  [actions.setInvoiceDisplayModeStatus]: createSetter("invoiceDisplayModeStatus"),
  [actions.setAmountMode]: createSetter("amountMode"),
  [actions.setSelectedItemUids]: createSetter("selectedItemUids"),
  [actions.setItemAmounts]: createSetter("itemAmounts"),
  [actions.setDeliveryFee]: createSetter("deliveryFee"),
  [actions.setSpecificAmount]: createSetter("specificAmount"),
  [actions.setPercentage]: createSetter("percentage"),
  [actions.setPartialSummary]: createSetter("partialSummary"),
  [actions.setPartialSummaryStatus]: createSetter("partialSummaryStatus"),
  [actions.setAdditionalProducts]: createSetter("additionalProducts"),
  [actions.setAdditionalProductsStatus]: createSetter("additionalProductsStatus"),
  [actions.setLastSubmittedId]: createSetter("lastSubmittedId"),
  [actions.setLastSubmittedPayload]: createSetter("lastSubmittedPayload"),
  [actions.reset]: () => ({ ...initialState, invoiceDate: null }),
});
